const ITEMS = [
  { value: '100K+', label: 'Active Users' },
  { value: '70+', label: 'Active WebOns' },
  { value: 'Multi-Chain', label: 'Architecture' },
  { value: '1 KYC', label: 'Multiple Services' },
  { value: 'Non-Custodial', label: 'Asset Control' },
  { value: 'IBAN', label: 'Banking Access' },
  { value: 'Web3-Native', label: 'Infrastructure' },
  { value: 'Nomo-ID', label: 'Identity Protocol' },
  { value: 'WebOn-Ready', label: 'Open Ecosystem' },
  { value: '100K+', label: 'Active Users' },
  { value: '70+', label: 'Active WebOns' },
  { value: 'Multi-Chain', label: 'Architecture' },
  { value: '1 KYC', label: 'Multiple Services' },
  { value: 'Non-Custodial', label: 'Asset Control' },
  { value: 'IBAN', label: 'Banking Access' },
  { value: 'Web3-Native', label: 'Infrastructure' },
  { value: 'Nomo-ID', label: 'Identity Protocol' },
  { value: 'WebOn-Ready', label: 'Open Ecosystem' },
];

export default function StatsTicker() {
  return (
    <div className="stats-ticker" aria-hidden="true">
      <div className="stats-ticker__track">
        {ITEMS.map((item, i) => (
          <span className="stats-ticker__item" key={i}>
            <span className="stats-ticker__value">{item.value}</span>
            <span className="stats-ticker__label">{item.label}</span>
            <span className="stats-ticker__sep">◆</span>
          </span>
        ))}
      </div>
    </div>
  );
}
